import { Grid, Layout, theme } from 'antd';
import Sider from 'antd/es/layout/Sider';
import { Content } from 'antd/es/layout/layout';
import { useContext } from 'react';
import { AppContext } from 'src/contexts/app.context';
import { TicketDetailProvider } from 'src/contexts/ticketDetail.context';
import TicketDetail from './TicketDetail';
import './TicketDetail.scss';
import TicketDetailSidebar from './TicketDetailSidebar';

const { useBreakpoint } = Grid;

const TicketAll = () => {
  const { isDetailSidebarCollapsed, isTicketDetailCollapsed } = useContext(AppContext);
  const screens = useBreakpoint();
  const {
    token: { colorBgContainer }
  } = theme.useToken();

  return (
    <Sider
      className='ticket-detail-layout'
      trigger={null}
      width={`calc(100% - ${screens.xxl ? '400px' : '320px'})`}
      collapsible
      collapsed={isTicketDetailCollapsed}
      style={{ background: colorBgContainer }}
      collapsedWidth={0}
    >
      <Layout hasSider>
        <TicketDetailProvider>
          <Content>
            <TicketDetail />
          </Content>
          <Sider
            trigger={null}
            width={screens.xxl ? '400px' : '320px'}
            collapsible
            collapsed={isDetailSidebarCollapsed}
            style={{ background: colorBgContainer }}
            collapsedWidth={50}
          >
            <TicketDetailSidebar />
          </Sider>
        </TicketDetailProvider>
      </Layout>
    </Sider>
  );
};

export default TicketAll;
